import { ActivatedRoute, Params, Router } from '@angular/router';
import { BlogArticle } from '@shared/models/blog-article.model';
import { BlogPage } from '@shared/models/blog-page.model';
import { BlogService, SocialShareService, TrackingService } from '@core/services';
import { Component, Inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { environment } from '@env/environment';
import { take } from 'rxjs/operators';
import { GhGlobal } from '@shared/helpers/global-functions';
import { ISocialShare } from '@core/seo/social-share/social-share.interface';
import { Location } from '@angular/common';
import { JsonLdService } from '@core/seo/json-ld/json-ld.service';
import { MetaTagAttr } from '@core/seo/social-share/meta-tag.interface';

@Component({
    selector: 'gh-search-results',
    templateUrl: 'search-results.component.html',
    standalone: false
})

export class SearchResultsComponent implements OnInit, OnDestroy {
  articles = [];
  terms = '';
  pager: BlogPage;
  currentPage: number = 1;
  pageIndex: number = 0;

  private parametersObservable: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private jsonLdService: JsonLdService,
    private socialShareService: SocialShareService,
    private blogService: BlogService,
    protected route: ActivatedRoute,
    private router: Router,
    protected location: Location,
    private trackingService: TrackingService,
  ) { }

  ngOnInit() {
    GhGlobal.injectStyle('', this.document);

    this.parametersObservable = this.route.params
      .subscribe((params) => {
        this.terms = params['terms'];
        // "articles" is obtained from 'SearchTagsResolver'
        const data = this.route.snapshot.data.searchResults;
        this.pager = data.pager;
        this.articles = data.articles;
        this.setSeoData(this.articles[0]);

        this.currentPage = +params.page ? +params.page : 1;
        this.pageIndex = this.currentPage - 1;
        this.getArticlesPaged(this.pageIndex.toString());
      });
  }

  gotoPage(ev: any) {
    this.getArticlesPaged(ev.pageIndex);
  }

  ngOnDestroy() {
    this.parametersObservable?.unsubscribe();
  }

  private getArticlesPaged(pageNumber = '0') {
    this.blogService.findArticlesByTerms(this.terms, pageNumber)
      .pipe(take(1))
      .subscribe((res: any) => {
        this.pager = res.pager;

        if (this.currentPage > this.pager.totalPages) {
          this.notFound();
          return;
        }

        this.articles = res.articles;
        this.setSeoData(this.articles[0]);
        //Only need to navigate if Using JS Paginator
        /*this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            index: pageNumber
          },
          queryParamsHandling: 'merge'
        });*/
      });
  }

  private notFound() {
    this.router.navigate(['/404']);
  }

  private setSeoData(article: BlogArticle) {
    const terms = this.terms ? this.terms.split(' ').join() : 'GoHenry';
    const seoData: ISocialShare = {
      title: 'GoHenry | blog search results',
      keywords: `${terms},blog`,
      description: 'The GoHenry pocket money card is a smart solution for managing your child\'s money and giving money to children, through an allowance prepaid card.',
      image: article ? article.heroImageUrl : environment.socialImage,
      url: environment.location + this.location.path(),
      type: article ? `article.${article.title}` : '',
      author: 'GoHenry',
      section: 'search results',
      published: '',
      modified: ''
    };

    const jsonLdObject = this.jsonLdService.getObject('Website', {
      name: 'GoHenry | Making every kid good with money – blog',
      url: seoData.url,
      description: seoData.description
    });

    const jsonLdObject2 = this.jsonLdService.getObject('Organization', {
      url: environment.website,
      logo: environment.jsonImage,
      legalName: 'GoHenry',
      name: 'GoHenry'
    });

    this.socialShareService.setData(seoData);
    this.socialShareService.setMetaTag({
      attr: MetaTagAttr.name, attrValue: 'robots', value: 'noindex, nofollow'
    });
    this.jsonLdService.setData([jsonLdObject, jsonLdObject2]);
    this.trackingService.setDataLayerAttributes({
      event: 'pageView',
      event_name: 'page_view',
      page: {
        location: this.location.path(),
        environment: environment.env,
        locale: environment.locale,
        title: seoData.title,
        feature: 'blog',
      }
    });
  }

}
